import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import NotifSVG2 from "../../../../../media/images/icons/notification-bing2";
import CustomToggleButton from "../../../../components/CustomToggleButton";
import { grey } from "@mui/material/colors";

interface Props {
  title: string;
  active: boolean;
  description: string;
  notifKey: string;
  handleSwitch: (key: string, status: boolean) => void;
}

export default function NotifCard({
  active,
  description,
  title,
  notifKey,
  handleSwitch,
}: Props) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        marginTop: "8px",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: active ? "secondary.main" : "info.light",
        backgroundColor: "bgColor.white",
        borderRadius: "16px",
        paddingX: "8px",
        paddingY: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <NotifSVG2
            color={
              active ? theme.palette.secondary.main : theme.palette.info.main
            }
          />
          <Typography
            sx={{
              color: active ? "secondary.main" : "#000",
              fontWeight: "600",
            }}
          >
            {title}
          </Typography>
        </Box>
        <CustomToggleButton
          status={active}
          handleToggle={(status) => handleSwitch(notifKey, status)}
        />
      </Box>
      <Box
        sx={{
          marginTop: "8px",

          backgroundColor: active ? theme.palette.secondary[50] : grey[100],
          padding: "8px",
          borderRadius: "4px",
        }}
      >
        <Typography
          sx={{
            color: active ? "secondary.main" : "#000",
            fontSize: "12px",
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
